import {Component, ViewChild} from '@angular/core';
import {ActionSheetController, AlertController, NavController, Select} from 'ionic-angular';
import {OrderService} from "../../services/OrderService";
import {OrderViewPage} from "../order-view/order-view";
import {OrderInfo} from "../nav/OrderInfo";
import {ActivityDate, ActivityWeek, DateService} from "../../services/DateService";
import {
  DailyTourPlanning,
  MissionOrderPlanningReport,
  Order,
  PlanningOperationDayReport,
  PlanningReportDay
} from "../../model/Order";
import {PhotoService} from "../../services/PhotoService";
import {MissionReportPhoto} from "../../model/MissionReportPhoto";
import {PcheckService} from "../../services/PcheckService";
import {apiconfig} from "../../app/api.config";
import {OperationService} from "../../services/OperationService";
import {FieldTeam, FieldTeamStoreUniverse} from "../../model/FieldTeam";
import {AuthService} from "../../services/AuthService";
import {OrderEditPage} from "../order-edit/order-edit";
import {LocupaUtilsServiceProvider} from "../../providers/locupa-utils-service/locupa-utils-service";
import {OperationCustomerPlanningSetting} from "../../model/Operation";
import {StartOrderPage} from "../start-order/start-order";
import {DailyViewPage} from "./daily-view";
import moment from "moment";
import {Locupa2Service} from '../../services/Locupa2Service';


/**
 * Generated class for the OrderListPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */


export class MatchingArea {
  areaId: number;
  areaLabel: string;
  sectorId: number;
  sectorLabel: string;
  type: string;
  selected: boolean;

  uiShouldHide: boolean;

  sectors: MatchingArea[] = [];

  toBadgeLabel(): string {
    if (this.sectorId == null)
      return this.areaLabel;
    else return this.sectorLabel + " (" + this.areaLabel + ")";
  }
}

export class MatchingOperation {
  id: number;
  name: string;
  type: string;
  selected: boolean;
}

@Component({
  selector: 'page-order-list',
  templateUrl: 'order-list.html',
})
export class OrderListPage {

  @ViewChild('selectLggContext') selectLggContextRef: Select;
  @ViewChild('selectAgent') selectAgentRef: Select;

  /**
   * flag to tell the UI it's currently loading
   */
  public uiLoadingComplete: boolean = false;

  //private orders: Order[];
  private planningReport: MissionOrderPlanningReport;


  public photoCounters: Map<number, MissionPhotoCounter[]>;
  private currentWeek: ActivityWeek;

  public ordersPerOperationKeys: string[] = [];

  public iconsURL: string = apiconfig.LOGA_ICONS;

  // settings cache to know if we are allowed to display items
  public showPresenceCheckInfosPerOp: Map<number, boolean>;
  public showPresenceCheckPhotos: Map<number, boolean>;
  public showCraPhotos: Map<number, boolean>;

  protected fieldTeamStoreUniverse: FieldTeamStoreUniverse;


  private uiSearchStoreName: string;
  private uiSearchWorkerName: string;

  private uiSearchArea: string;
  private allLogaAreas: MatchingArea[] = [];
  private allPearlsAreas: MatchingArea[] = [];
  private uiMatchingAreas: MatchingArea[] = [];
  private uiSelectedAreas: MatchingArea[] = [];

  private uiSearchOperation: string;
  private allOperations: MatchingOperation[] = [];
  private uiMatchingOperation: MatchingOperation[] = [];
  private uiSelectedOperation: MatchingOperation[] = [];

  private uiShowSearch: boolean;
  private uiNumberOfVisibleOrders: number;

  private uiTimeLineDates: ActivityDate[] = [];
  private currentDate: ActivityDate;
  bubbleNumber: string[] = [];

  lggContexts: LggContext[] = [];
  lggContextId: number;

  agents: Agent [] = [];
  fieldAgentId: number;
  emptyPlanning: boolean = true;

  constructor(public navCtrl: NavController,
              public orderService: OrderService,
              public dateService: DateService,
              public photoService: PhotoService,
              public pcheckService: PcheckService,
              public operationService: OperationService,
              public authService: AuthService,
              public locupaUtilsServiceProvider: LocupaUtilsServiceProvider,
              public actionSheetCtrl: ActionSheetController,
              public alertCtrl: AlertController,
              public locupa2Service: Locupa2Service) {

  }

  ionViewWillEnter() {
    if (!this.currentWeek)
      this.currentWeek = this.dateService.getCurrentWeek();

    console.log('order-list ::: ionViewWillEnter ')

    this.orderService.loadCurrentFieldTeam(false, null).then(fieldTeam => {
      this.fieldTeamStoreUniverse = fieldTeam;
      this.initLogaAreas();
      this.searchOrders();
    });

    for (let i = 0; i < 15; i++) {
      this.bubbleNumber[i] = '&#' + (9312 + i) + ';';
    }

    this.orderService.loadLggContexts().then(contexts => {
      this.lggContexts = contexts;
    });

  }

  onLoadOrder(p_orderId: number, index: number) {

    let orderInfo: OrderInfo;
    orderInfo = new OrderInfo();
    console.log("looking for order with id: " + p_orderId);
    let selectOrder: Order = this.planningReport.findOrderById(p_orderId);
    if (selectOrder != undefined) {
      orderInfo.order = selectOrder.id;

      // operation info
      orderInfo.operation.id = selectOrder.operation.id;
      orderInfo.operation.name = selectOrder.operation.name;

      // store info
      orderInfo.store.id = selectOrder.location.id;
      orderInfo.store.name = selectOrder.location.name;

      // load pcheck for this day before opening the details of the order
      this.pcheckService.findPcheck(selectOrder.id)
        .then((pchecks) => {
          if (selectOrder.customerEditPermissionAllowed)
            this.navCtrl.push(OrderEditPage, {orderInfo, pchecks});
          else
            this.navCtrl.push(OrderViewPage, {orderInfo, pchecks});
        });

    } else {

      let alert = this.alertCtrl.create({
        title: 'Intervention',
        subTitle: "Impossible de retrouver les informations de cette intervention. (id= " + p_orderId + ")" +
          "Merci ré-essayer ultérieurement ou de contacter le responsable IMPACT.",
        buttons: ['Fermer'],
      });
      alert.present();

    }

  }

  /**
   *
   * @param durationInMinutes
   */
  toFormatMissionDuration(durationInMinutes: number): string {
    let nbHours = Math.floor(durationInMinutes / 60);
    let nbMinutes = Math.floor(durationInMinutes % 60);

    if (nbMinutes && nbMinutes > 0) {
      return nbHours + "h" + nbMinutes;
    }

    return nbHours + "h";
  }

  newOrder() {
    this.navCtrl.push(StartOrderPage);
  }

  nextWeek() {
    this.currentWeek.addWeek();
    //this.orders = [];
    this.planningReport = null;
    this.searchOrders();
  }

  previousWeek() {
    this.currentWeek.removeWeek();
    //this.orders = [];
    this.planningReport = null;
    this.searchOrders();
  }


  searchOrders() {

    this.uiTimeLineDates = this.currentWeek.activityDates;
    this.currentDate = null;

    this.uiLoadingComplete = false;

    this.photoCounters = new Map();
    this.showPresenceCheckInfosPerOp = new Map();
    this.showPresenceCheckPhotos = new Map();
    this.showCraPhotos = new Map();

    this.orderService.loadOrderReport(this.currentWeek.getStartDate(), undefined, undefined).then((report) => {

      this.planningReport = report;

      this.emptyPlanning = report.getAllOrders().length === 0 && report.getAllPearlsPlannings().length === 0;

      // -- we want to store in cache the operation settings
      let operationSettingsCache = [];
      let allP = [];
      let allOperationIds: number[] = [];

      if (report.days != null)
        report.days.forEach(day => {
          if (day.operationReports != null)
            day.operationReports.forEach(opRep => {
              if (opRep.planningEntry.planningEntryType === 'LOGA') {
                if (allOperationIds.indexOf(opRep.operationId) < 0)
                  allOperationIds.push(opRep.operationId);
              }

              this.addOperation(opRep);
              this.addPearlsArea(opRep);
            });
        })


      for (let id of allOperationIds) {
        allP.push(this.operationService.loadOperationCustomerPlanningSettings(id).then(planificationSettings => {
          operationSettingsCache[id] = planificationSettings;
          this.showPresenceCheckInfosPerOp.set(id, planificationSettings.showPresenceCheckInfos)
          // doit on voir l'information "nb photos" ?
          this.showPresenceCheckPhotos.set(id, planificationSettings.showCheckInQuestionnaire !== 'NO');
          this.showCraPhotos.set(id, planificationSettings.showCra !== 'NO');

          console.log("just loaded setting for operation id :" + id);
        }));
      }


      Promise.all(allP).then(() => {
        // operation settings is now loaded we can process with content loading / rendering
        for (let order of report.getAllOrders()) {

          order.uiPresenceCheckString = this.processAlertOnPcheckString(order.pcheckAlerts);

          if (!this.ordersPerOperationKeys.find(opName => opName === order.operation.name))
            this.ordersPerOperationKeys.push(order.operation.name);
        }
      }).then(() => {

        let ordersPerOperationId: Map<number, Order[]> = this.locupaUtilsServiceProvider.groupBy(report.getAllOrders(), function (a: Order) {
          return a.operation.id;
        });

        ordersPerOperationId.forEach((value: Order[], key: number) => {

          let i, j, chunk = 200;
          for (i = 0, j = value.length; i < j; i += chunk) {
            let bucket = value.slice(i, i + chunk);

            let missionIds = [];
            bucket.forEach(m => missionIds.push(m.id));

            this.photoService.searchPhoto(null, null, key, null, missionIds)
              .then(
                (missionsPhotoReport: MissionReportPhoto[]) => {
                  if (missionsPhotoReport != null)
                    missionsPhotoReport.forEach((ph) => {
                      this.appendPhotoToLocalCounter(ph, ph.operationId);
                    });
                });
          }
        });
      });

      this.runSearchFiltering();

      this.uiLoadingComplete = true;
    });
  }

  addOperation(opRep: PlanningOperationDayReport) {
    if (this.allOperations.filter(o => o.id === opRep.operationId && o.type === opRep.planningEntry.planningEntryType).length === 0) {
      let operation = new MatchingOperation();
      operation.id = opRep.operationId;
      operation.type = opRep.planningEntry.planningEntryType;
      operation.name = opRep.label;
      if (operation.type !== 'LOGA') {
        operation.name = this.lggContexts.filter(c => c.value === operation.id)[0].title
      }
      this.allOperations.push(operation);
    }
  }

  addPearlsArea(opRep: PlanningOperationDayReport) {
    if (opRep.planningEntry.planningEntryType !== 'LOGA') {
      opRep.planningEntry.pearlsPlanningEntries.forEach(ppe => {
        if (ppe.areaId) {
          let areas = this.allPearlsAreas.filter(o => o.areaId === ppe.areaId);
          let currentArea;
          if (areas.length === 0) {
            currentArea = new MatchingArea();
            currentArea.areaId = ppe.areaId;
            currentArea.areaLabel = ppe.areaName;
            currentArea.type = 'PEARLS';
            this.allPearlsAreas.push(currentArea);
          } else {
            currentArea = areas[0];
          }

          if (currentArea.sectors.filter(s => s.sectorId === ppe.sectorId).length === 0) {
            let sector = new MatchingArea();
            sector.areaId = ppe.areaId;
            sector.areaLabel = ppe.areaName;
            sector.sectorId = ppe.sectorId;
            sector.sectorLabel = ppe.sectorName;
            sector.type = 'PEARLS';
            currentArea.sectors.push(sector);
          }
        }
      })
    }
  }

  /**
   * will check the current operation setting configuration, and increment counter according to photo type
   * @param ph
   * @param opSetting
   * @param cnt
   */
  private appendPhotoToLocalCounter(ph: MissionReportPhoto, operationId: number) {

    if (this.photoCounters.get(ph.missionId) === undefined) {
      let counterTab: MissionPhotoCounter[] = [];
      this.photoCounters.set(ph.missionId, counterTab);
    }

    // get array
    let counterTab: MissionPhotoCounter[] = this.photoCounters.get(ph.missionId);

    // find element from array
    let cnt: MissionPhotoCounter = counterTab.find(o => (o.orderId === ph.missionId));

    // change element or add new one
    if (cnt == null) {
      cnt = new MissionPhotoCounter();
      cnt.orderId = ph.missionId;
      cnt.counter = 0;
      cnt.operationId = operationId;
      counterTab.push(cnt)
    }

    cnt.counter = cnt.counter + 1;

  }

  private processAlertOnPcheckString(pcheckAlerts: any[]): string {
    let alert: string = '';
    if (pcheckAlerts != null) {
      pcheckAlerts.forEach(a => {
        alert = alert.concat(a);
      });
    }
    return alert;
  }

  public showPresenceCheckInfos(p_operation: number): boolean {
    if (this.showPresenceCheckInfosPerOp !== undefined)
      return this.showPresenceCheckInfosPerOp.get(p_operation);
    return false;
  }

  public showNbPictures(p_operationId: number): boolean {
    if (this.showPresenceCheckPhotos !== undefined && this.showCraPhotos !== undefined) {
      return this.showPresenceCheckPhotos.get(p_operationId) || this.showCraPhotos.get(p_operationId);
    }
    return false;
  }


  /**
   * filter content, according to current user provided filter values in filter bar
   */
  runSearchFiltering() {

    if (this.planningReport != null)
      this.planningReport.getAllOrders().forEach(o => {

        let shouldHide = false;

        if (this.uiSelectedOperation != null && this.uiSelectedOperation.length > 0) {
          let atLestOneArea = false;

          this.uiSelectedOperation.forEach(op => {
            if (!atLestOneArea) {
              if (op.type === 'LOGA' && op.id === o.operation.id) {
                atLestOneArea = true;
              }
            }
          })

          if (!atLestOneArea)
            shouldHide = true;
        }

        if (this.uiSelectedAreas != null && this.uiSelectedAreas.length > 0) {
          let atLestOneArea = false;

          this.uiSelectedAreas.forEach(sa => {
            if (!atLestOneArea) {
              if (sa.sectorId != null) {
                if (sa.type === 'LOGA' && sa.sectorId == o.location.customerSector) atLestOneArea = true;
              } else {
                if (sa.type === 'LOGA' && sa.areaId == o.location.customerArea) atLestOneArea = true;
              }
            }
          })

          if (!atLestOneArea)
            shouldHide = true;
        }

        if (!shouldHide && this.currentDate != null) {
          let isOk = false;

          if (o.activities != null)
            for (let act of o.activities)
              if (act.day == this.currentDate.dateStamp)
                isOk = true;

          if (!isOk)
            shouldHide = true;
        }

        if (!shouldHide && this.uiSearchStoreName != null && this.uiSearchStoreName.length > 2) {
          let isOk = false;

          if (o.location == null) {
            isOk = false;
          } else if (o.location.name.toUpperCase().indexOf(this.uiSearchStoreName.toUpperCase()) >= 0) {
            isOk = true;
          } else if (o.location.address != null && o.location.address.city != null && o.location.address.city.toUpperCase().indexOf(this.uiSearchStoreName.toUpperCase()) >= 0) {
            isOk = true;
          }

          if (!isOk)
            shouldHide = true;
        }

        if (!shouldHide && this.uiSearchWorkerName && this.uiSearchWorkerName.length > 2) {
          //worker name search applies only for Pearls items since on Loga this is not anonymized
          shouldHide = true;
        }

        o.uiShouldHide = shouldHide;
      });

    this.planningReport.getAllPearlsPlannings().forEach(o => {

      let shouldHide = false;

      if (this.uiSelectedOperation != null && this.uiSelectedOperation.length > 0) {
        let atLestOneArea = false;

        this.uiSelectedOperation.forEach(op => {
          if (!atLestOneArea) {
            if (op.type !== 'LOGA' && op.id === o.ctxId) {
              atLestOneArea = true;
            }
          }
        })

        if (!atLestOneArea)
          shouldHide = true;
      }

      if (this.uiSelectedAreas != null && this.uiSelectedAreas.length > 0) {
        let atLestOneArea = false;

        this.uiSelectedAreas.forEach(sa => {
          if (!atLestOneArea) {
            if (sa.sectorId != null) {
              if (sa.type === 'PEARLS' && sa.sectorId == o.sectorId) atLestOneArea = true;
            } else {
              if (sa.type === 'PEARLS' && sa.areaId == o.areaId) atLestOneArea = true;
            }
          }
        })

        if (!atLestOneArea)
          shouldHide = true;
      }

      if (!shouldHide && this.currentDate != null) {
        let isOk = false;

        if (o.logaDay != null && o.logaDay == this.currentDate.dateStamp) {
          isOk = true;
        }
        if (!isOk)
          shouldHide = true;
      }

      if (!shouldHide && this.uiSearchStoreName != null && this.uiSearchStoreName.length > 2) {
        let isOk = false;

        if (o.storeName == null) {
          isOk = false;
        } else if (o.storeName.toUpperCase().indexOf(this.uiSearchStoreName.toUpperCase()) >= 0) {
          isOk = true;
        } else if (o.address != null && o.address.city != null && o.address.city.toUpperCase().indexOf(this.uiSearchStoreName.toUpperCase()) >= 0) {
          isOk = true;
        }

        if (!isOk)
          shouldHide = true;
      }

      if (!shouldHide && this.uiSearchWorkerName && this.uiSearchWorkerName.length > 2) {
        let isOk = false;
        if (o.salesRepName != null && o.salesRepName.toUpperCase().indexOf(this.uiSearchWorkerName.toUpperCase()) > -1) {
          isOk = true;
        }

        if (!isOk)
          shouldHide = true;
      }

      o.uiShouldHide = shouldHide;
    });

    this.uiNumberOfVisibleOrders = this.planningReport.getAllOrders().filter(o => !o.uiShouldHide).length +
      this.planningReport.getAllPearlsPlannings().filter(o => !o.uiShouldHide).length;
  }

  toggleShowSearch() {
    this.uiShowSearch = !this.uiShowSearch;
    if (!this.uiShowSearch) {
      this.runSearchFiltering();
    }
  }

  displayDay(d: ActivityDate) {
    this.currentDate = d;
    this.runSearchFiltering();
  }

  /**
   *
   */
  initLogaAreas() {

    if (this.fieldTeamStoreUniverse != null) {
      this.fieldTeamStoreUniverse.findAreas().forEach(a => {

        let areas = this.allLogaAreas.filter(la => la.areaId === a.areaId);

        let currentArea;
        if (areas.length === 0) {
          currentArea = new MatchingArea();
          currentArea.areaLabel = a.areaName;
          currentArea.areaId = a.areaId;
          currentArea.type = 'LOGA';

          if (a.sectors != null) {
            a.sectors.forEach(s => {
              let mma = new MatchingArea();
              mma.areaLabel = a.areaName;
              mma.areaId = a.areaId;
              mma.sectorId = s.sectorId;
              mma.sectorLabel = s.sectorName;
              mma.type = 'LOGA';
              currentArea.sectors.push(mma);
            });
          }
          this.allLogaAreas.push(currentArea);
        }
      });
    }
  }

  runGeoFiltering() {
    let r: MatchingArea[] = [];

    if (this.uiSearchArea != null && this.uiSearchArea.length > 0) {
      this.allLogaAreas.forEach(a => this.setMatchingSearchedArea(a));
      this.allPearlsAreas.forEach(a => this.setMatchingSearchedArea(a));

      r.push(...this.allLogaAreas.filter(a => a.uiShouldHide === false));
      r.push(...this.allPearlsAreas.filter(a => a.uiShouldHide === false));
    }
    this.uiMatchingAreas = r;
  }

  setMatchingSearchedArea(matchingArea: MatchingArea) {
    let uiShouldHide = true;
    if (matchingArea.areaLabel.toUpperCase().includes(this.uiSearchArea.toUpperCase()) || matchingArea.sectors.filter(s => s.sectorLabel.toUpperCase().includes(this.uiSearchArea.toUpperCase())).length > 0) {
      uiShouldHide = false;
      matchingArea.sectors.forEach(s => {
        s.uiShouldHide = !s.toBadgeLabel().toUpperCase().includes(this.uiSearchArea.toUpperCase());
      })
    }
    matchingArea.uiShouldHide = uiShouldHide;
  }

  runOperationFiltering() {
    let r: MatchingOperation[] = [];

    if (this.uiSearchOperation != null && this.uiSearchOperation.length > 0)
      if (this.allOperations != null) {
        this.allOperations.forEach(op => {
          if (op.name.toUpperCase().includes(this.uiSearchOperation.toUpperCase())) {
            r.push(op);
          }
        });
      }
    this.uiMatchingOperation = r;
  }

  areaSelect(a: MatchingArea, b: boolean) {
    a.selected = b;

    if (a.selected) {
      this.uiSelectedAreas.push(a);
    } else {
      let r = [];
      this.uiSelectedAreas.forEach(aa => {
        if (a.toBadgeLabel() != aa.toBadgeLabel()) {
          r.push(aa);
        }
      });
      this.uiSelectedAreas = r;
    }
    this.runSearchFiltering();
  }

  operationSelect(operation: MatchingOperation, selected: boolean) {
    operation.selected = selected;

    if (operation.selected) {
      this.uiSelectedOperation.push(operation);
    } else {
      let r = [];
      this.uiSelectedOperation.forEach(op => {
        if (operation.id != op.id) {
          r.push(op);
        }
      });
      this.uiSelectedOperation = r;
    }
    this.runSearchFiltering();
  }

  closeAreasSelector() {
    this.uiMatchingAreas = [];
    this.uiSearchArea = '';
  }

  closeOperationSelector() {
    this.uiMatchingOperation = [];
    this.uiSearchOperation = '';
  }

  openTourPlanningPage(event, dailyTourPlanning: DailyTourPlanning): Promise<any> {
    if (event != null) event.stopPropagation();

    return this.navCtrl.push(DailyViewPage, {
      day: dailyTourPlanning.referenceDate,
      tourPlanningIdentifier: dailyTourPlanning.id
    });
  }


  showTourPlanningActionSheets(d: PlanningReportDay) {
    let theDate = new ActivityDate().withTimeStamp(d.logaDay).asDate();
    let newTourIdentifierSuggest = 'Tournée ' + (moment(theDate)).format("YY[-]MMM[-]DD[.]ddd")

    let buttons = [];
    buttons.push({
      text: 'Nouvelle Tournée',
      icon: "add",
      handler: () => {
        let alert = this.alertCtrl.create({
          title: "Nom de la Tournée",
          inputs: [{name: 'tourIdentifier', placeholder: 'Identifiant Tournée', value: newTourIdentifierSuggest}],
          buttons: [{
            text: "Ajouter",
            handler: data => {
              this.orderService.createDayTourPlanning(data.tourIdentifier, d.logaDay).then(tour => {
                return this.openTourPlanningPage(null, tour);
              }).catch(err => {
                let alertErr = this.alertCtrl.create({
                  title: 'Erreur de Planification de tournée',
                  subTitle: "Impossible de créer la tournée. Veuillez contacter votre interlocteur Agence.",
                  buttons: ['Fermer'],
                });
                return alertErr.present();
              })
            }
          }]
        });
        return alert.present();
      }
    });


    d.dailyTourPlannings.forEach(dtp => {
      buttons.push({
        text: 'Modifier ' + dtp.name,
        icon: "map",
        handler: () => {
          return this.navCtrl.push(DailyViewPage, {
            day: d.logaDay,
            tourPlanningIdentifier: dtp.id
          });
        }
      });
    });

    const actionSheet = this.actionSheetCtrl.create({
      title: 'Plan de Tournée',
      buttons: buttons
    });

    return actionSheet.present();
  }

  openLggContextSelect() {
    if (this.lggContexts.length > 1) {
      this.lggContextId = 0;    // force the trigger of onChange event by having no default selection
      this.selectLggContextRef.open();    // open select lgg context dialog
    } else if (this.lggContexts.length === 1) {
      this.lggContextId = this.lggContexts[0].value;
      this.openSelectAgent();
    }
  }

  openSelectAgent() {
    if (this.lggContextId > 0) {   // avoid the handling of the changing: this.lggContextId = 0
      this.orderService.loadAgents(this.lggContextId).then(agents => {
        if (agents.length > 0) {
          if (agents.length === 1) {
            this.fieldAgentId = agents[0].value;
            this.openPlanning();
          } else {
            this.fieldAgentId = 0  // force the trigger of onChange event by having no default selection
            this.agents = agents;
            setTimeout(() => {
              this.selectAgentRef.open();  // open select agent dialog
            }, 0);
          }
        } else {
          let lggContextTitle = this.lggContexts.filter(ctx => ctx.title)[0].title;
          this.showNoAgentAlert(lggContextTitle);
        }
      })
    }
  }

  showNoAgentAlert(lggContextTitle: string) {
    const alert = this.alertCtrl.create({
      title: 'Notification',
      message: `Il n'y a aucun agent pour contexte <b>${lggContextTitle}</b>`,
      buttons: ['Ok']
    });
    alert.present();
  }

  openPlanning() {
    if (this.fieldAgentId > 0) {  // avoid the handling of the changing: this.fieldAgentId = 0
      this.locupa2Service.openLocupa2Window(`/field-agent-planning/${this.lggContextId}/${this.fieldAgentId}`);
    }
  }

  onLoadPearlsPlanningEntry(planningEntryType: string, p_ctxId: number, p_planningEntryId: number, p_salesRep: number, index: number) {
    if (planningEntryType === 'STORECHECK') {
      this.locupa2Service.openLocupa2Window(`/storecheck-dashboard/` + p_ctxId + "/" + p_planningEntryId + "/" + p_salesRep);
    } else if (planningEntryType === 'EVENT') {
      this.locupa2Service.openLocupa2Window(`/event/` + p_ctxId + "/" + p_planningEntryId + "/" + p_salesRep);
    }
  }

}

export class MissionPhotoCounter {
  public orderId: number;
  public counter: number;
  public operationId: number;
}

/* export class Agent {
  public id: number;
  public name: string;
}

export interface LggContext {
  id: number;
  name: string;
}
*/
export interface LggContext {
  value: number;
  title: string;
}

export interface Agent {
  value: number;
  title: string;
}




// WEBPACK FOOTER //
// ./src/pages/order-list/order-list.ts